import { EventEmitter, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { SystemcodeApi } from "../api-service/system-code/systemcode-api";
import { GroupMsgData } from "../signalr-service";
import { ClinicDataService } from "../data-service/clinic-data-service";
import { EasyNotificationService } from "../easy-notification.service";
import { PricingApi } from "../api-service/pricing/pricing-api";
import { MainLayoutService } from "src/app/layout/services/main-layout.service";
import { LocalPrintService } from "../local-print.service";
import { LocalStoragesService } from "../local-storages.service";


@Injectable({
  providedIn: 'root'
})
export class ConsoleEventHandler {
  onWaitingListNeedRefresh = new EventEmitter();
  /**
   *
   */
  constructor(private clinicData: ClinicDataService,
    private notify: EasyNotificationService,
    private mainlayout:MainLayoutService,
    private printer:LocalPrintService,
    private localStorage:LocalStoragesService
  ) {
  }
  /** 執行事件 */
  Invoke(evt: GroupMsgData) {
    if (evt.Type == 'Action') {
      this.doAction(evt).then(x=>x);
    } else if (evt.Type == 'Notify') {
      this.doNotify(evt);
    }
  }
  /** 動作事件 */
  private async doAction(evt: GroupMsgData) {
    switch (evt.Act) {
      case "SPSRecieved":
        var computerName = evt.Arg['ComputerName'];
        var d = this.localStorage.getItem('ConsoleInfo');
        // 與參數同名電腦才執行列印
        if(computerName == d.ComputerName){
          var regId = evt.Arg['RegId'];
          var printSetting = evt.Arg['PrintSetting'] ?? "00";
          if(printSetting[0] == "1"){ // 列印藥袋
            await this.printer.printDrugbag(regId);
          }
          if(printSetting[1] == "1"){ // 列印收據
            await this.printer.printReceipt(regId);
          }
        }
        break;
    }
  }
  private doNotify(evt: GroupMsgData) {
    this.notify.showInfo(evt.Arg);
  }
}
